import axios from 'axios';

export const authenticateBreefAccessLink = async (token: string) => {
  try {
    
    // The token goes in the header, not the address, so it never lands in a server's access log
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/Breefs/authenticate-link`, null, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  }catch (error) {
    console.error('Error authenticating Breef access link:', error);
    throw error;
  }
};

export const getBreefReport = async (userId: string) => {
  try {
    
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/Breefs/breef-report/user/${userId}`);
    return response.data;
  }catch (error) {
    console.error('Error fetching Breef Report:', error);
    throw error;
  }
};